
import { reachGoal } from './utils/metrika.js';

export default {
    name: 'MeatPageFooter',
    props: {
        footer: {
            type: Object,
            required: true
        },
    },
    methods: { reachGoal }
}
